import { Modal } from 'baby-design'
import NiceModal, { useModal } from '@ebay/nice-modal-react'

const RecordContributionModal = NiceModal.create(() => {
  const modal = useModal()

  return (
    <Modal handleClose={() => modal.hide()} isOpen={modal.visible}>
      <h1>Record a contribution</h1>
    </Modal>
  )
})

export default RecordContributionModal
